/**
 * @module constants
 * @description Constants used across the application
 */

/**
 * An array of the possible transient pricing algorithms returned from the facilities endpoint
 * @property {string} 0="matrix_smart_rates"
 * @property {string} 1="matrix_flex_rates"
 * @property {string} 2="matrix_precision_pricing"
 * @property {string} 3="matrix_iq"
 * @property {string} 4="legacy"
 * @property {string} 5="rate_experiment"
 */
export const TRANSIENT_PRICING_ALGORITHMS = /** @type {const} */ ([
    'matrix_smart_rates',
    'matrix_flex_rates',
    'matrix_precision_pricing',
    'matrix_iq',
    'legacy',
    'rate_experiment',
]);

/**
 * An object with the types of transient pricing algorithms as keys and an array of the transient pricing algorithm names that fall into that category as values
 * @type {object}
 * @property {string[]} flexRates - The algorithm name(s) for Flex Rates; Current response from the endpoint returns `matrix_smart_rates`, but will be updated to `matrix_flex_rates` in the future
 * @property {string[]} spotHeroIQ - The algorithm name(s) for SpotHero IQ; Current response from the endpoint returns `matrix_precision_pricing`, but will be updated to `matrix_iq` in the future
 * @property {string[]} legacy - The algorithm name(s) for Legacy Rates
 * @property {string[]} rateExperiment - The algorithm name(s) for the Rate Experiment; When the Rate Experiment is present, all of the applicable pricing algorithms in that rate experiment will be returned alongside the `rate_experiment` algorithm
 */
export const CATEGORIZED_ALGORITHMS = {
    flexRates: ['matrix_smart_rates', 'matrix_flex_rates'],
    spotHeroIQ: ['matrix_precision_pricing', 'matrix_iq'],
    legacy: ['legacy'],
    rateExperiment: ['rate_experiment'],
};

/**
 * An object containing the types of interpolation algorithms
 * @type {object}
 * @property {string} logarithmic - The logarithmic interpolation algorithm
 * @property {string} linear - The linear interpolation algorithm
 * @property {string} none - No interpolation algorithm
 */
export const INTERPOLATION_ALGORITHMS = {
    logarithmic: 'log',
    linear: 'linear',
    none: 'none',
};

export const RESERVATION_TYPES = {
    TRANSIENT: {
        value: 'transient',
        label: 'Transient or Airport',
    },
    MONTHLY: {
        value: 'monthly',
        label: 'Monthly',
    },
    EVENT: {
        value: 'event',
        label: 'Event',
    },
    EMPLOYEE: {
        value: 'employee',
        label: 'Employee',
    },
    COMP: {
        value: 'comp',
        label: 'Comp',
    },
};
